import { REFRESH_RAPORT_DATA, CLEAR_RAPORT_REFRESH } from '../types';

export default (state = {}, { type, payload }) => {
  switch (type) {
    case REFRESH_RAPORT_DATA:
      return payload;
    case CLEAR_RAPORT_REFRESH:
      return {};
    default:
      return state;
  }
};
